export const getDataAlign = (align) => {
    if (!align)
        return {};
    return {
        [`data-align-${align}`]: true,
    };
};
